export default __webpack_public_path__ + "static/media/background.b0a5f134.svg";